module.exports = __webpack_public_path__ + "img/book_mot_banner_mobile.e23639d.webp";